export default {
  plan: '',
  no_consumption: '',
  period: {},
  consumptionPeriods: [],
};
